import Note from "components/Atoms/Note"
import React from "react"
const DisplayStockNote = ({ stock }) => {
  if (!stock.offerStockCount) return <div />
  return (
    <Note intent="primary">
      Note: <b>{stock.offerStockCount} units</b> of this item will be available
      for online bookings{" "}
    </Note>
  )
}

export default DisplayStockNote
